import React, { useState } from "react";
import { supabase } from "../supabaseClient";

function DialogImport({ isOpen, onClose }) {
  const [wordsFile, setWordsFile] = useState(null);
  const [dialogsFile, setDialogsFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const handleImport = async () => {
    if (!wordsFile || !dialogsFile) {
      alert("Please provide both files");
      return;
    }

    setIsImporting(true);
    setImportResult(null);

    try {
      // Read both files
      const wordsText = await wordsFile.text();
      const dialogsText = await dialogsFile.text();

      const words = JSON.parse(wordsText);
      const dialogs = JSON.parse(dialogsText);

      let stats = {
        total: dialogs.length,
        imported: 0,
        skipped: 0,
      };

      // Create a map of old word_id to new word_id
      const wordIdMap = new Map();
      for (const word of words) {
        const { data: existingWord } = await supabase
          .from("words")
          .select("word_id")
          .eq("word_text", word.word_text)
          .single();

        if (existingWord) {
          wordIdMap.set(word.word_id, existingWord.word_id);
        }
      }

      // Import dialogs
      for (const dialog of dialogs) {
        const newWordId = wordIdMap.get(dialog.word_id);

        if (!newWordId) {
          stats.skipped++;
          continue;
        }

        const { error: dialogError } = await supabase.from("dialogs").insert([
          {
            word_id: newWordId,
            dialog_id_legacy: dialog.dialog_id,
            sentence: dialog.sentence,
            teacher_question: dialog.teacher_question,
            student_answer: dialog.student_answer,
            teacher_conclusion: dialog.teacher_conclusion,
            is_correct: dialog.is_correct,
            reviewed: dialog.reviewed,
            created_at: dialog.create_date,
          },
        ]);

        if (dialogError) {
          console.error("Error importing dialog:", dialogError);
          stats.skipped++;
        } else {
          stats.imported++;
        }
      }

      setImportResult(stats);
      console.log("Import completed:", stats);
    } catch (error) {
      console.error("Error importing dialogs:", error);
      const errorMessage = error.message || JSON.stringify(error, null, 2);
      alert("Error importing dialogs: " + errorMessage);
    } finally {
      setIsImporting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg max-w-2xl w-full">
        <h3 className="text-2xl font-bold mb-4">Import Dialogs</h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Words Export File (JSON)
            </label>
            <input
              type="file"
              accept=".json"
              onChange={(e) => setWordsFile(e.target.files[0])}
              className="file-input file-input-bordered w-full"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Dialogs Export File (JSON)
            </label>
            <input
              type="file"
              accept=".json"
              onChange={(e) => setDialogsFile(e.target.files[0])}
              className="file-input file-input-bordered w-full"
            />
          </div>

          {importResult && (
            <div className="bg-green-100 p-4 rounded-lg">
              <p className="text-green-800">
                Import completed!
                <br />
                Total dialogs: {importResult.total}
                <br />
                Successfully imported: {importResult.imported}
                <br />
                Skipped: {importResult.skipped}
              </p>
            </div>
          )}

          <div className="flex justify-end space-x-2">
            <button
              onClick={() => {
                onClose();
                setImportResult(null);
                setWordsFile(null);
                setDialogsFile(null);
              }}
              className="btn"
            >
              Cancel
            </button>
            <button
              onClick={handleImport}
              disabled={isImporting}
              className="btn btn-primary"
            >
              {isImporting ? "Importing..." : "Start Import"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DialogImport;
